import React from "react";
import AuthPageBase from "./AuthPageBase";

const LogoutPage: React.FC = () => {
  return (
    <AuthPageBase
      titleMessageId="logoutPage.seeYouSoonText"
      titleDefaultMessage="See you soon!"
      bodyMessageId="logoutPage.youAreLoggedOutText"
      bodyDefaultMessage="You are logged out of Smart Merchandiser."
      paperPadding="140px 30px"
      buttonContainerStyle={{ marginTop: "40px" }}
      buttonStyle={{}}
    />
  );
};

export default LogoutPage;
